import { HiChevronLeft, HiMagnifyingGlass } from "react-icons/hi2";
import {
  useNavigate,
  useLocation as useLocationReactRouterDom,
} from "react-router-dom";
import ScrollRestore from "../../components/common/scroll-restore";
import { track } from "@amplitude/analytics-browser";
import SearchResults from "./components/search-results";
import { useSearchKeyword } from "./hooks/use-search-keyword";
import { useStoreSearch } from "./hooks/use-store-search";

const Search = () => {
  const { keyword, setKeyword, debouncedKeyword } = useSearchKeyword();
  const { data, loading, refetch } = useStoreSearch(debouncedKeyword);
  const navigate = useNavigate();
  const location = useLocationReactRouterDom();

  const handleSearch = () => {
    if (debouncedKeyword) {
      track("검색 페이지 검색 버튼 클릭", {
        keyword: debouncedKeyword,
      });
      refetch();
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      track("검색 페이지 검색 엔터 키 누름", {
        keyword: debouncedKeyword,
      });
      handleSearch();
    }
  };

  return (
    <div className="w-full min-h-screen h-full flex flex-col bg-white overflow-y-scroll">
      <div className="sticky top-0 z-10 bg-white px-4 py-3">
        <div className="flex items-center gap-2">
          <button
            onClick={() => {
              track("검색 페이지 뒤로가기 버튼 클릭");
              navigate("/");
            }}
          >
            <HiChevronLeft className="w-6 h-6 text-gray-500" />
          </button>
          <div className="flex-1 relative">
            <input
              autoFocus={location.state?.from === "/"}
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder="매장 이름, 주소를 검색해보세요"
              className="w-full h-12 pl-4 pr-12 rounded-3xl border border-gray-300 focus:outline-none focus:border-primary"
            />
            <button
              onClick={handleSearch}
              className="absolute right-3 top-1/2 -translate-y-1/2 p-1 active:bg-gray-100 rounded-full transition-colors"
            >
              <HiMagnifyingGlass className="w-6 h-6 text-gray-500" />
            </button>
          </div>
        </div>
      </div>

      <ScrollRestore
        id="scroll-search"
        className="flex-1 p-4"
        initRestore={data != null && data.storeSearch.length > 0}
      >
        <SearchResults
          loading={loading}
          data={data}
          debouncedKeyword={debouncedKeyword}
        />
      </ScrollRestore>
    </div>
  );
};

export default Search;
